var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _rect2, _path18, _rect3, _rect4, _polygon, _rect5, _polygon2, _polygon3, _polygon4, _rect6, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 157.72",
    style: {
      enableBackground: "new 0 0 612 157.72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EC2024;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000036223605370302160730000013274816064571369392_);}\n\t.st3{fill:url(#SVGID_00000178170343437658654630000003425841647344770434_);}\n\t.st4{fill:url(#SVGID_00000131332179792064581810000010549820530683273364_);}\n\t.st5{fill:url(#SVGID_00000152229841364747769170000012581377278205470090_);}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#AFAFB0;}\n\t.st8{fill:url(#SVGID_00000060007644473538469620000011268135977269407407_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.46,38.95h-8.25l1.23-6h24.07l-1.23,6h-8.22l-4.18,20.85h-7.6L214.46,38.95z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.21,51.73l4.57,8.07h-7.95l-4-7.14H238l-1.42,7.14H229l5.37-26.88h11.48c6.87,0,10.83,3.19,10.83,8.56 C256.81,46.2,253.74,50.41,249.21,51.73z M244.76,38.91h-4l-1.61,7.87h4.53c3.34,0,5.3-1.61,5.3-4.57 C249,39.95,247.37,38.91,244.76,38.91L244.76,38.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.74,54.58H265.3l-3.11,5.22h-8l17.23-26.88h7.49l6.49,26.88h-7.56L276.74,54.58z M275.59,48.97l-1.81-8.66 l-5.14,8.71L275.59,48.97z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.34,48.51c0-9.33,6.87-16.12,16.85-16.12c5,0,9,1.8,10.91,5.06l-5.49,4.38c-1.25-2.06-3.52-3.27-5.92-3.15 c-5.22,0-8.67,4-8.67,9.33c0,3.61,2.46,6,6.56,6c2.55,0.01,4.96-1.13,6.57-3.11l4.49,4.41c-3,3.65-7,5-11.79,5 C293.6,60.31,288.34,55.54,288.34,48.51z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.45,45.31l9,14.51H334l-6.18-9.68l-3.5,3.17L323,59.8h-7.48l5.37-26.88h7.49l-2.19,11l12.13-11h8.94 L333.45,45.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.21,
    y1: 112.2471,
    x2: 347.27,
    y2: 112.2471,
    gradientTransform: "matrix(1 0 0 -1 0 158.6242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB1D25"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.46,38.95h-8.25l1.23-6h24.07l-1.23,6h-8.22l-4.18,20.85h-7.6L214.46,38.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098218304169900931620000015988855388330503343_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.21,
    y1: 112.2621,
    x2: 347.27,
    y2: 112.2621,
    gradientTransform: "matrix(1 0 0 -1 0 158.6242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB1D25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098218304169900931620000015988855388330503343_)"
    },
    d: "M249.21,51.73l4.57,8.07h-7.95l-4-7.14H238 l-1.42,7.14H229l5.37-26.88h11.48c6.87,0,10.83,3.19,10.83,8.56C256.81,46.2,253.74,50.41,249.21,51.73z M244.76,38.91h-4 l-1.61,7.87h4.53c3.34,0,5.3-1.61,5.3-4.57C249,39.95,247.37,38.91,244.76,38.91L244.76,38.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054267159987046979340000004485508269747951276_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.21,
    y1: 112.2621,
    x2: 347.27,
    y2: 112.2621,
    gradientTransform: "matrix(1 0 0 -1 0 158.6242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB1D25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054267159987046979340000004485508269747951276_)"
    },
    d: "M276.74,54.58H265.3l-3.11,5.22h-8 l17.23-26.88h7.49l6.49,26.88h-7.56L276.74,54.58z M275.59,48.97l-1.81-8.66l-5.14,8.71L275.59,48.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007405969598468618600000003133708245299059388_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.21,
    y1: 112.2721,
    x2: 347.27,
    y2: 112.2721,
    gradientTransform: "matrix(1 0 0 -1 0 158.6242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB1D25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007405969598468618600000003133708245299059388_)"
    },
    d: "M288.34,48.51 c0-9.33,6.87-16.12,16.85-16.12c5,0,9,1.8,10.91,5.06l-5.49,4.38c-1.25-2.06-3.52-3.27-5.92-3.15c-5.22,0-8.67,4-8.67,9.33 c0,3.61,2.46,6,6.56,6c2.55,0.01,4.96-1.13,6.57-3.11l4.49,4.41c-3,3.65-7,5-11.79,5C293.6,60.31,288.34,55.54,288.34,48.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049179366054193812760000002295849088602324923_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.21,
    y1: 112.2521,
    x2: 347.27,
    y2: 112.2521,
    gradientTransform: "matrix(1 0 0 -1 0 158.6242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2024"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EB1D25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049179366054193812760000002295849088602324923_)"
    },
    d: "M333.45,45.31l9,14.51H334l-6.18-9.68 l-3.5,3.17L323,59.8h-7.48l5.37-26.88h7.49l-2.19,11l12.13-11h8.94L333.45,45.31z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.2,66.25H228c14.17,0,22.82,7.34,22.82,19.11c0,16.13-11.7,26.4-28.41,26.4h-23.32L208.2,66.25z  M222.76,101.49c9.62,0,15-6.64,15-15.35c0-6.05-3.84-9.62-11.25-9.62H219l-4.94,25L222.76,101.49z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.56,76.19l-1.49,7.67h20.22l-1.89,9.63h-20.28l-1.63,8.32h23.86l-2.08,9.95H252.8l9.1-45.51h35.63l-2,9.94 H272.56z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.2,76.45h-14l2.08-10.2h40.77L340,76.45h-13.93L319,111.76h-12.89L313.2,76.45z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M368.27,102.92H348.9l-5.27,8.84H330l29.19-45.51h12.68l11,45.51h-12.78L368.27,102.92z M366.32,93.42 l-3.06-14.76l-8.71,14.76H366.32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M395.71,66.25h12.87l-9.1,45.51h-12.87L395.71,66.25z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M417.75,66.25h12.87l-7,35.3h21.72l-2.08,10.21h-34.61L417.75,66.25z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M457.41,66.25h12.87l-9.1,45.51h-12.87L457.41,66.25z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M522.69,66.25l-9.1,45.51H503l-15-25l-5,25h-12.65l9.1-45.51h10.6l15.08,24.9l4.94-24.9H522.69z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M558,88.03h11.38l-3.83,19.18c-5.25,3.69-11.54,5.61-17.95,5.46c-13.91,0-22.89-8.13-22.89-20 c0-15.8,11.64-27.31,28.94-27.31c9.1,0,15.73,2.93,19.83,8.39l-9.24,7.28c-3-3.7-6.5-5-11.18-5c-9.36,0-15.34,6.7-15.34,15.8 c0,6.11,4.16,10.21,11.64,10.21c2.05,0.02,4.09-0.36,6-1.11L558,88.03z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M100.5,26.66H59.24v41.26h41.26V26.66z M93.79,61.21H66V33.37h27.79V61.21z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.82,
    y: 39.24,
    className: "st6",
    width: 16.1,
    height: 16.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.14,26.66v41.26h41.26V26.66H121.14z M155.69,61.21h-27.84V33.37h27.84V61.21z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.72,
    y: 39.24,
    className: "st6",
    width: 16.1,
    height: 16.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.24,129.82h41.26V88.56H59.24V129.82z M66,95.31h27.79v27.8H66V95.31z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.82,
    y: 101.14,
    className: "st7",
    width: 16.1,
    height: 16.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.24,
    y: 74.88,
    width: 9.56,
    height: 6.71
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "74.5,74.88 74.5,81.59 107.47,81.59 110.57,81.59 114.18,81.59 114.18,26.66 107.47,26.66  107.47,74.88 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 88.56,
    className: "st7",
    width: 26.42,
    height: 6.71
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "155.69,123.11 133.89,123.11 133.89,129.82 155.69,129.82 162.4,129.82 162.4,123.11 162.4,104.83  155.69,104.83 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "140.6,111.54 149.32,111.54 149.32,104.83 140.6,104.83 136.07,104.83 133.89,104.83 133.89,115.9  140.6,115.9 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "142.61,90.32 149.32,90.32 149.32,74.88 144.62,74.88 142.61,74.88 121.14,74.88 121.14,81.59  142.61,81.59 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137829769857892252180000017108867425579926922_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.53,
    y1: 80.3871,
    x2: 183.11,
    y2: 80.3871,
    gradientTransform: "matrix(1 0 0 -1 0 158.6242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#ED2830"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#ED2830"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.53,
    y: 74.88,
    style: {
      fill: "url(#SVGID_00000137829769857892252180000017108867425579926922_)"
    },
    width: 144.58,
    height: 6.71
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 155.36,
    y: 88.56,
    className: "st7",
    width: 7.05,
    height: 6.71
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "117.7,110.53 107.47,110.53 107.47,113.55 107.47,117.24 107.47,129.82 114.18,129.82 114.18,117.24  117.7,117.24 124.41,117.24 124.41,110.53 124.41,104.83 117.7,104.83 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "154.85,6.53 154.85,13.24 175.82,13.24 175.82,34.21 182.53,34.21 182.53,6.53 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "39.11,34.21 45.82,34.21 45.82,13.24 66.79,13.24 66.79,6.53 39.11,6.53 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "66.79,149.95 66.79,143.24 45.82,143.24 45.82,122.27 39.11,122.27 39.11,149.95 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "182.53,122.27 175.82,122.27 175.82,143.24 154.85,143.24 154.85,149.95 182.53,149.95 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoWhite);
export default __webpack_public_path__ + "static/media/new_logo_white.0dcf047a4805768bbd1ab4614f16425a.svg";
export { ForwardRef as ReactComponent };